import { Component } from '@angular/core';

@Component({
    selector: 'app-welcome-advisors',
    templateUrl: './welcome-advisors.component.html',
    styleUrls: ['./welcome-advisors.component.css'],
    standalone: false
})
export class WelcomeAdvisorsComponent {

}
